import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';
import '@fontsource/instrument-serif/400.css'; // wordmark only
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { MARKET } from '../shared/market.generated';
import { App } from './App';
import { TxProvider } from './data/tx';
import './styles.css';
import { WalletProvider } from './wallet/WalletProvider';

if (import.meta.env.DEV) void import('./wallet/devSigner').then((m) => m.installDevSigner());

// Email / passkey sign-in (Privy) is a separate chunk: the app renders with extension wallets right away and the
// option appears in the wallet picker once the chunk has loaded. Builds without an app id never fetch it.
const PrivyRoot = MARKET.privyAppId ? lazy(() => import('./wallet/privy')) : null;

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: true, retry: 2 } } });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <WalletProvider>
        {PrivyRoot && <Suspense fallback={null}><PrivyRoot /></Suspense>}
        <TxProvider>
          <App />
        </TxProvider>
      </WalletProvider>
    </QueryClientProvider>
  </StrictMode>,
);
